import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-logo-nav" }
const _hoisted_2 = { class: "nav-button" }
const _hoisted_3 = { class: "nav-notice" }
const _hoisted_4 = {
  key: 0,
  class: "nav-badge-new-notice",
  src: "/server/necs/images/badge_new_notice.svg"
}
const _hoisted_5 = {
  class: "nav-contents-dropdown",
  id: "global_nav_s"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "nav" }
const _hoisted_9 = { class: "nav-contents" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  id: "badge-new-notice",
  class: "badge-new-notice",
  src: "/server/necs/images/badge_new_notice.svg"
}
const _hoisted_13 = { class: "glonav" }
const _hoisted_14 = {
  class: "glonav-contents",
  id: "global_nav"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "badge-new",
  src: "/server/necs/images/badge_new.svg",
  alt: ""
}
const _hoisted_18 = {
  key: 0,
  class: "dashboard"
}
const _hoisted_19 = { class: "top-area" }
const _hoisted_20 = { class: "profile-area" }
const _hoisted_21 = { class: "profile-welcome" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "profile-info" }
const _hoisted_24 = { class: "welcome-area" }
const _hoisted_25 = {
  key: 0,
  class: "nickname-honor"
}
const _hoisted_26 = { class: "welcome-msg" }
const _hoisted_27 = { class: "profile-topics" }
const _hoisted_28 = { class: "hospital-visit-text" }
const _hoisted_29 = { class: "hospital-visit-schedule-wrapper" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "hospital-visit-schedule-date" }
const _hoisted_32 = { class: "hospital-visit-schedule-time" }
const _hoisted_33 = { class: "hospital-visit-schedule-note" }
const _hoisted_34 = { class: "bottom-area" }
const _hoisted_35 = { class: "select-date" }
const _hoisted_36 = { class: "select-date-item" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "selected-date-area" }
const _hoisted_40 = {
  key: 0,
  class: "selected-date-icon",
  src: "/server/necs/images/icon_daily_record_completed.svg"
}
const _hoisted_41 = { class: "selected-date-date" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["src"]
const _hoisted_44 = {
  key: 0,
  class: "select-date-question"
}
const _hoisted_45 = { class: "select-body-condition" }
const _hoisted_46 = { class: "select-body-condition-list" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "select-body-condition-text" }
const _hoisted_49 = {
  key: 0,
  class: "speech-balloon body-condition-balloon"
}
const _hoisted_50 = { class: "speech-balloon-content" }
const _hoisted_51 = { class: "balloon-header" }
const _hoisted_52 = { class: "balloon-title" }
const _hoisted_53 = { class: "balloon-text" }
const _hoisted_54 = { class: "record-button-container" }
const _hoisted_55 = {
  key: 0,
  class: "speech-balloon record-balloon"
}
const _hoisted_56 = { class: "speech-balloon-content" }
const _hoisted_57 = { class: "balloon-header" }
const _hoisted_58 = { class: "balloon-title" }
const _hoisted_59 = { class: "balloon-text" }

import { useWindowSize } from "@vueuse/core";
import {
  computed,
  reactive,
  ref,
  watch,
  getCurrentInstance,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import dayjs from "dayjs";
import { _$t } from "@/utils/i18n";
import { processing, processend } from "@/utils/view";
import { useStore } from "vuex";
import CommonMessage from "@/views/base/CommonMessage.vue";
import { Home } from "@/models/home";
import {
  DailyCondition,
  DailyFeeling,
  DailyNote,
  HospitalVisit,
  Option,
} from "@/models/home/types/indes";

// 体調記録選択肢のclass名

export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    activeMenu: {},
    nickname: {},
    welcomeMessage: {},
    previewImage: {},
    nextVisit: {},
    dailyCondition: {},
    dailyFeelings: {},
    dailyNotes: {},
    dailyConditionOptions: {},
    todayConditionHiddenFlag: { type: Boolean },
    symptomHiddenFlag: { type: Boolean }
  },
  emits: [
  "get-home-data",
  "open-modal",
  "selected-date-change",
],
  setup(__props: any, { emit: __emit }) {

const DAILY_CONDITION_CLASSNAME = [
  "excellent",
  "good",
  "normal",
  "poor",
  "terrible",
];
// 下部グロナビで固定NEWバッジを表示するメニュー
// const FIXED_NEW_BADGE_MENU_IDS = ["Community", "my-record", "my-report"];
const FIXED_NEW_BADGE_MENU_IDS = [];

const router = useRouter();
const store = useStore();
const home = new Home();
const { width } = useWindowSize();

// ▼ トースト表示用
const { appContext } = getCurrentInstance()!;
const $toast = appContext.config.globalProperties.$toast;

const route = useRoute();
const date = route.query?.date as string;

const dateFormatter = (date: Date) => {
  const formatter = new Intl.DateTimeFormat("ja-JP", {
    month: "long",
    day: "numeric",
    weekday: "short",
  });
  return formatter.format(date);
};

const getWeekDate = () => {
  const dates = [];

  for (let i = 0; i < 7; i++) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    dates.push(d);
  }

  return dates;
};

const weekDates = getWeekDate();

const currentDate = ref(
  weekDates.find((d) => dayjs(d).isSame(dayjs(date), "day")) ?? weekDates[0]
);

const displayDate = computed(() => dateFormatter(currentDate.value));

const changeDay = (offset: number) => {
  const currentIndex = weekDates.indexOf(currentDate.value);
  currentDate.value = weekDates[currentIndex + offset];
  emit("selected-date-change", dayjs(currentDate.value).format("YYYY-MM-DD"));
};

const hasNext = computed(() => weekDates.indexOf(currentDate.value) === 0);
const hasPrev = computed(
  () => weekDates.indexOf(currentDate.value) === weekDates.length - 1
);

const isToday = computed(
  () => currentDate.value.getDate() === new Date().getDate()
);

const props = __props;

const emit = __emit;

const bodyConditionPopup = ref<boolean>(false);
const recordPopup = ref<boolean>(false);

const checkPopups = () => {
  const bodyConditionPopupClosed = props.todayConditionHiddenFlag;
  const recordPopupClosed = props.symptomHiddenFlag;
  bodyConditionPopup.value = false;
  recordPopup.value = false;
  if (
    props.dailyCondition &&
    props.dailyCondition.length === 0 &&
    bodyConditionPopupClosed
  ) {
    bodyConditionPopup.value = true;
    return;
  }

  if (
    props.dailyFeelings?.length === 0 &&
    props.dailyNotes?.length === 0 &&
    recordPopupClosed
  ) {
    recordPopup.value = true;
  }
};

watch(
  [
    () => props.todayConditionHiddenFlag,
    () => props.symptomHiddenFlag,
    () => props.dailyCondition,
    () => props.dailyNotes,
  ],
  () => checkPopups()
);

const closeBodyConditionPopup = async () => {
  bodyConditionPopup.value = false;
  await home.setTodayConditionHiddenFlag();
  emit("get-home-data");
};

const closeRecordPopup = async () => {
  recordPopup.value = false;
  await home.setSymptomHiddenFlag();
  emit("get-home-data");
};

const goToHospitalVisit = (hospitalVisitId: number) => {
  router.push({ name: "ClinicNote", params: { hospitalVisitId } });
};

const getNextVisitDate = (nextVisitTimeStr: string) => {
  if (!nextVisitTimeStr) return;
  const nextVisit = new Date(nextVisitTimeStr);
  const hours = String(nextVisit.getHours()).padStart(2, "0");
  const minutes = String(nextVisit.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}～`;
};

const nextVisits = computed<HospitalVisit[]>(() => {
  const visits = props.nextVisit ?? [];
  if (visits.length === 0) return [];

  const today = dayjs().startOf("day");

  //「近日中の受診（今日以降）」で絞り込み、最も近い日付を検索する
  const upcoming = visits.filter(
    (v) => !dayjs(v.visit_date).startOf("day").isBefore(today)
  );
  if (upcoming.length === 0) return [];

  const closestDate = upcoming.reduce((min, v) => {
    const d = dayjs(v.visit_date);
    return d.isBefore(min) ? d : min;
  }, dayjs(upcoming[0].visit_date));

  return upcoming.filter((v) =>
    dayjs(v.visit_date).startOf("day").isSame(closestDate.startOf("day"))
  );
});

const dailyCondition = computed(() => {
  return props.dailyCondition && props.dailyCondition.length !== 0
    ? props.dailyCondition.map((item: DailyCondition) => ({
      answeredDate: String(item.answered_date).slice(0, 10),
      bodyConditionId: Number(item.body_condition_option_id),
    }))
    : [];
});

const currentDayDailyCondition = computed(() => {
  const selectedDate = dayjs(currentDate.value).format("YYYY-MM-DD");
  return dailyCondition.value.find(
    (item) => item?.answeredDate === selectedDate
  );
});

// 選択中の日付で「体調、症状・こころノート、気持ち」がすべて記録済みか
const isDailyRecordCompleted = computed(() => {
  const hasDailyCondition = !!currentDayDailyCondition.value;
  const hasDailyNote = (props.dailyNotes?.length ?? 0) > 0;
  const hasDailyFeeling = (props.dailyFeelings?.length ?? 0) > 0;
  return hasDailyCondition && hasDailyNote && hasDailyFeeling;
});

const handleModalOpen = () => {
  emit("open-modal");
};

const recordDailyCondition = async (bodyConditionId: number) => {
  try {
    await home
      .recordDailyCondition({
        answeredDate: dayjs(currentDate.value).format("YYYY-MM-DD"),
        bodyConditionId,
      })
      .then(([model, _response, err]) => {
        if (!err) {
          // トースト表示
          $toast({
            message: [1, 2].includes(bodyConditionId)
              ? _$t("home_body_condition_bad_message_saved")
              : _$t("home_body_condition_good_message_saved"),
            icon: "success",
          });
          emit("get-home-data");
        } else {
          const status = err.error?.response?.status;
          if (status === 408) {
            const decodedMessage = decodeURIComponent(
              err.error?.response?.data?.message
            );
            throw decodedMessage;
          }
          return;
        }
      });
  } catch (e) {
    console.error(e);
  }
};

const navMenuItems = [
  {
    menuId: "notifications",
    name: "header_topmenu_notice",
    spIcon:
      "/server/necs/images/notifications_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.png",
    pcIcon: "/server/necs/images/header_nav_news.svg",
    route: "notifications",
  },
  {
    menuId: "profile",
    name: "header_topmenu_profile",
    spIcon: "/server/necs/images/person_FILL0_wght500_GRAD0_opsz48.png",
    pcIcon: "/server/necs/images/header_nav_profile.svg",
    route: "Profile",
  },
  {
    menuId: "logout",
    name: "header_topmenu_logout",
    spIcon: "/server/necs/images/logout_24dp_FILL0_wght600_GRAD0_opsz24.png",
    pcIcon: "/server/necs/images/header_nav_logout.svg",
    route: "logout",
  },
];

const glonavMenuItems = [
  {
    menuId: "home",
    name: "footer_nav_home",
    route: "home",
    icon: "/server/necs/images/header_nav_home.svg",
  },
  // {
  //   menuId: "Community",
  //   name: "footer_nav_info_exchange",
  //   route: "Community",
  //   icon: "/server/necs/images/header_nav_summary.svg",
  // },
  {
    menuId: "article",
    name: "footer_nav_article",
    route: "article",
    icon: "/server/necs/images/header_nav_article.svg",
  },
  {
    menuId: "my-record",
    name: "footer_nav_record",
    route: "MyRecord",
    icon: "/server/necs/images/header_nav_my_record.svg",
  },
  {
    menuId: "my-report",
    name: width.value < 930 ? "footer_nav_report" : "header_nav_report",
    route: "MyReport",
    icon: "/server/necs/images/header_nav_my_report.svg",
  },
];

const messageConfig = reactive({
  show: false,
  okButtonHide: true,
  cancelButton: true,
  safe: false,
  message: _$t("header_logout_msg"),
  okName: _$t("header_logout_ok_button"),
  cancelName: _$t("header_logout_cancel_button"),
  logout: (): void => {
    processend();
    messageConfig.show = false;
    store.dispatch("disposeUser");
    store.commit("setCheckHasNickname", false);
    store.commit("resetHasNewNotification");
    window.location.href = "/cms/login";
  },
  cancel: (): void => {
    processend();
    messageConfig.show = false;
  },
});

const openLink = (route: string) => {
  if (route === "logout") {
    msgBoxLogoutOpen();
  } else if (route) {
    router.push({ name: route });
  }
};

const msgBoxLogoutOpen = (): void => {
  processing();
  messageConfig.show = true;
};

// mobileナビゲーション選択時、スクロールを禁止する
const mobileNavToggle = (event: Event) => {
  const target = event.currentTarget as HTMLInputElement;
  const wrapper = document.querySelector(".wrapper");
  if (!target || !wrapper) return;
  if (target.checked) {
    wrapper.classList.add("noscroll");
  } else {
    wrapper.classList.remove("noscroll");
  }
};

// 常設バナーリンク
const openArticleCondition = () => {
  window.open("https://member.kanshin-hiroba.jp/cms#/article/detail/394");
};

const openArticleClinicNote = () => {
  window.open("https://member.kanshin-hiroba.jp/cms#/article/detail/395");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "header-icon" }, [
        _createElementVNode("a", { href: "#" }, [
          _createElementVNode("img", {
            src: "/server/necs/images/kanshin_logo.png",
            alt: "Logo"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "nav-notice-icons",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openLink('notifications')))
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("img", {
              class: "nav-notice-icon",
              src: "/server/necs/images/notice_orange.svg",
              alt: ""
            }, null, -1)),
            (_unref(store).getters.getHasNewNotification)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("input", {
          type: "checkbox",
          class: "nav-toggle",
          id: "nav-toggle",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileNavToggle($event)))
        }),
        _cache[14] || (_cache[14] = _createElementVNode("label", {
          for: "nav-toggle",
          class: "nav-button-top"
        }, [
          _createElementVNode("img", { src: "/server/necs/images/menu-btn.png" })
        ], -1)),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navMenuItems, (item) => {
            return _createElementVNode("li", {
              class: _normalizeClass(["nav-contents-dropdown-item", { active: item.menuId === props.activeMenu }]),
              key: item.menuId,
              onClick: ($event: any) => (openLink(item.route))
            }, [
              _createElementVNode("img", {
                src: item.spIcon,
                class: "nav-contents-icon"
              }, null, 8, _hoisted_7),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.name)), 1)
            ], 10, _hoisted_6)
          }), 64)),
          _createElementVNode("li", {
            class: "nav-contents-dropdown-item-banner",
            onClick: openArticleCondition
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("img", {
              class: "nav-contents-icon",
              src: "/server/necs/images/banner_system_usage.png"
            }, null, -1)
          ])),
          _createElementVNode("li", {
            class: "nav-contents-dropdown-item-banner",
            onClick: openArticleClinicNote
          }, _cache[12] || (_cache[12] = [
            _createElementVNode("img", {
              class: "nav-contents-icon",
              src: "/server/necs/images/bana_img02.png"
            }, null, -1)
          ])),
          _createElementVNode("li", {
            class: "nav-contents-dropdown-item-banner",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/welfare')))
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("img", {
              class: "nav-contents-icon",
              src: "/server/necs/images/banner_welfare_usage.png"
            }, null, -1)
          ]))
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "overlay" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navMenuItems, (item) => {
            return _createElementVNode("li", {
              class: _normalizeClass(["nav-contents-item", { active: item.menuId === props.activeMenu }]),
              key: item.menuId,
              onClick: ($event: any) => (openLink(item.route))
            }, [
              _createElementVNode("img", {
                src: item.pcIcon,
                class: "nav-contents-icon"
              }, null, 8, _hoisted_11),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.name)), 1),
              (item.menuId === 'notifications')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(store).getters.getHasNewNotification)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 10, _hoisted_10)
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("ul", _hoisted_14, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(glonavMenuItems, (item) => {
          return _createElementVNode("li", {
            class: _normalizeClass(["glonav-contents-item", { active: item.menuId === props.activeMenu }]),
            key: item.menuId,
            onClick: ($event: any) => (openLink(item.route))
          }, [
            _createElementVNode("img", {
              src: item.icon,
              class: "glonav-contents-icon"
            }, null, 8, _hoisted_16),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.name)), 1),
            (FIXED_NEW_BADGE_MENU_IDS.includes(item.menuId))
              ? (_openBlock(), _createElementBlock("img", _hoisted_17))
              : _createCommentVNode("", true)
          ], 10, _hoisted_15)
        }), 64))
      ])
    ]),
    (_ctx.activeMenu === 'home')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  src: _ctx.previewImage,
                  alt: "Preview",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/profile'))),
                  class: "welcome-profile-image"
                }, null, 8, _hoisted_22),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, [
                    _createElementVNode("span", {
                      class: "welcome-nickname",
                      id: "nickname",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/profile')))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.nickname), 1),
                      (_ctx.nickname)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("home_nickname_mrs")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("home_nickname_welcome")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.welcomeMessage), 1)
                ])
              ])
            ]),
            (nextVisits.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["hospital-visit-area", { 'hospital-visit-area-multiple': nextVisits.value.length > 1 }])
                }, [
                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("home_text_next_hospital_visit")), 1),
                  _createElementVNode("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextVisits.value, (visit) => {
                      return (_openBlock(), _createElementBlock("button", {
                        onClick: ($event: any) => (goToHospitalVisit(visit.hospital_visit_id)),
                        class: "hospital-visit-schedule",
                        key: visit.hospital_visit_id
                      }, [
                        _createElementVNode("p", _hoisted_31, [
                          _createTextVNode(_toDisplayString(dateFormatter(new Date(visit.visit_date))) + " ", 1),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(getNextVisitDate(visit.visit_time)), 1)
                        ]),
                        _createElementVNode("p", _hoisted_33, [
                          _createTextVNode(_toDisplayString(_ctx.$t("home_text_look_at_examination_note")) + " ", 1),
                          _cache[17] || (_cache[17] = _createElementVNode("img", {
                            class: "hospital-visit-schedule-icon",
                            src: "/server/necs/images/arrow_right_339db2.svg"
                          }, null, -1))
                        ])
                      ], 8, _hoisted_30))
                    }), 128))
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (changeDay(1))),
                  disabled: hasPrev.value,
                  class: "select-date-item-button"
                }, [
                  _createElementVNode("img", {
                    src: 
                  hasPrev.value
                    ? '/server/necs/images/arrow_left_ddd.svg'
                    : '/server/necs/images/arrow_left_888.svg'
                
                  }, null, 8, _hoisted_38)
                ], 8, _hoisted_37),
                _createElementVNode("div", _hoisted_39, [
                  (isDailyRecordCompleted.value)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_41, _toDisplayString(displayDate.value), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (changeDay(-1))),
                  disabled: hasNext.value,
                  class: "select-date-item-button"
                }, [
                  _createElementVNode("img", {
                    src: 
                  hasNext.value
                    ? '/server/necs/images/arrow_right_ddd.svg'
                    : '/server/necs/images/arrow_right_888.svg'
                
                  }, null, 8, _hoisted_43)
                ], 8, _hoisted_42)
              ]),
              (isToday.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.$t("home_text_how_is_todays_health")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("ul", _hoisted_46, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dailyConditionOptions, (condition, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: _normalizeClass([
                'select-body-condition-item',
                DAILY_CONDITION_CLASSNAME[index],
                currentDayDailyCondition.value
                  ? currentDayDailyCondition.value.bodyConditionId ===
                    condition.option_id
                    ? 'active'
                    : 'inactive'
                  : '',
              ])
                  }, [
                    _createElementVNode("div", {
                      class: "select-body-condition-icon",
                      onClick: ($event: any) => (recordDailyCondition(condition.option_id))
                    }, _cache[18] || (_cache[18] = [
                      _createElementVNode("span", { class: "select-body-condition-icon-img" }, null, -1)
                    ]), 8, _hoisted_47),
                    _createElementVNode("p", _hoisted_48, _toDisplayString(condition.display_name), 1)
                  ], 2))
                }), 128))
              ]),
              (bodyConditionPopup.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _cache[19] || (_cache[19] = _createElementVNode("img", {
                          src: "/server/necs/images/light_bulb.svg",
                          class: "balloon-icon"
                        }, null, -1)),
                        _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t("header_popup_title_record_todays_physical_condition")), 1)
                      ]),
                      _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.$t(
                    "header_text_select_best_option_for_todays_physical_condition"
                  )), 1),
                      _createElementVNode("img", {
                        class: "balloon-close",
                        src: "/server/necs/images/close-btn.png",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (closeBodyConditionPopup()))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("button", {
                class: "record-button",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (handleModalOpen()))
              }, [
                _cache[20] || (_cache[20] = _createElementVNode("img", {
                  src: "/server/necs/images/record_daily_detail.svg",
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("home_button_record_detail_symptoms")), 1)
              ]),
              (!bodyConditionPopup.value && recordPopup.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _cache[21] || (_cache[21] = _createElementVNode("img", {
                          src: "/server/necs/images/light_bulb.svg",
                          class: "balloon-icon"
                        }, null, -1)),
                        _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t("header_popup_title_record_symptoms_feelings")), 1)
                      ]),
                      _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t("header_text_review_recorded_entries_on_list")), 1),
                      _createElementVNode("img", {
                        class: "balloon-close",
                        src: "/server/necs/images/close-btn.png",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (closeRecordPopup()))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (messageConfig.show)
      ? (_openBlock(), _createBlock(CommonMessage, _mergeProps({ key: 1 }, messageConfig, {
          onOk: messageConfig.logout,
          onCancel: messageConfig.cancel
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ]))
}
}

})